import { render, staticRenderFns } from "./AliPlayer.vue?vue&type=template&id=1fd67074&"
import script from "./AliPlayer.vue?vue&type=script&lang=js&"
export * from "./AliPlayer.vue?vue&type=script&lang=js&"
import style0 from "./AliPlayer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports